module.exports = __webpack_public_path__ + "img/sort-up.387b0b5b.svg";